import React from 'react';
import ReactDom from 'react-dom/client';
import { Provider } from 'react-redux';
import globals, { initApp } from 'src/init.js';
import 'src/polyfills.js';
import RootConnected from 'src/root/index.js';
import 'antd/dist/antd.css'; // 'antd/dist/antd.less'
import Modal from 'src/common/components/Modal.js';

// App attachment node
const rootNode = document.getElementsByTagName('body')[0];

// App modules
const modules = [
  'common', 'posHelper', 'root'
];

// React
const root = ReactDom.createRoot(rootNode);
initApp(modules).then(() => {
  root.render(
    <Provider store={globals.Store}>
      <RootConnected moduleMaps={globals.ModuleMaps} />
      <Modal/>
    </Provider>
  );
});